









import Vue from 'vue';

export default Vue.extend({
  props: ['placeHolderText', 'value'],
  methods: {
    updateInput: function (event: Event & { target: HTMLInputElement }): void {
      const { target } = event;
      if (target) {
        this.$emit('input', target.value);
      }
    },
  },
});
